<template>
    <div class="modal" :class="{'is-active':isActiveAttachmentModal}">
        <div class="modal-background" @click="CloseAttachmentModalFunc()"></div>
        <div class="modal-content animate__animated animate__zoomIn animate__faster">
                <div class="modal-header">
                    <div class="level">
                        <div class="level-left">
                            <h2 class="modal-title"> {{ headerFlightText }} - {{ attachmentType }}</h2>
                        </div>
                        <div class="level-right">
                            <button class="close-btn" title="Full Screen" @click="openNewTab()">
                                <font-awesome-icon icon="expand" />
                            </button>                        
                            <button class="close-btn" @click="CloseAttachmentModalFunc()" title="Close">
                                <font-awesome-icon icon="times" />
                            </button>
                        </div>
                    </div>
                </div>

                    <div v-if="isloadedstat == 0">
                        <loading-button/>
                    </div>
                    <embed v-if="Comprendercomponentstat ==1" type="application/pdf"
                           :src="activeUrl"
                           @load="isloaded(1)"
                           @onloadstart="isloaded(0)"
                           width="100%" height="91%" alt="pdf"
                           background-color="0xFF525659" top-toolbar-height="56" full-frame=""
                           internalinstanceid="21"
                           title="CHROME">
            </div>

        </div>
</template>

<script>
    import LoadingButton from "./LoadingButton";
    import {loadingMixin} from "../../utils/mixins";
    import {mapState} from "vuex";

    export default {
        name: "ShowAttachmentModal",
        props: ['isActiveAttachmentModal', 'activeUrl', 'activeFKey' , 'headerFlightText', 'attachmentType'],
        data() {
            return {
                modalsize: {
                    width: "70%",
                    height: "80%"
                },
                isloadedstat:0,
            }
        },

        computed:{

              ...mapState("schedule",[
                 "activeFkeyForZip",
              ]),

              Comprendercomponentstat :
              {
                      get()
                      {
                          if(this.isActiveAttachmentModal == true)
                          {
                              return 1;
                          }
                          else
                          {
                              return 0;
                          }
                      }
              }
        },


        created() {


        },


        mixins: [loadingMixin],

        components: {
            LoadingButton,
        },

        methods: {

            CloseAttachmentModalFunc()
            {
                this.isloadedstat =0;

                this.$emit('closeAttachmentModal');

            },

            fullscreenModal() {
                this.modalsize.width = '100%',
                    this.modalsize.height = '100%'
            },
            defaultScreenModal() {
                this.modalsize.width = '70%',
                    this.modalsize.height = '50%'
            },
            openNewTab() {
                window.open(this.activeUrl, 'Image', 'resizable=1');
            },
            goToHistory() {
                this.$router.push({name: 'TechnicalHistory', params: {fKey:this.activeFKey}});
            },

            isloaded(stat){
                this.isloadedstat=stat;

            }
        },

        mounted() {
            document.body.addEventListener('keyup', e => {
                if (e.keyCode === 27) { //ESC


                    this.isloadedstat =0;
                    this.$emit('closeAttachmentModal');

                    // this.$emit('closeAttachmentModal');
                }
            })



        },
    }
</script>

<style scoped>
.modal-content {
  border-radius: 16px;
  width: 90%;
  max-width: 1500px;
  height: 100vh;
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  position: relative;
}

.modal-header {
  background: #ffffff;
  border-bottom: 1px solid #e5e7eb;
  padding: 20px 32px;
}

.header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
